import { AppNotification, AppNotificationType } from './notification.model';

export function mapNotification(payload: any): AppNotification {

	return {
		id: payload.id ?? crypto.randomUUID(),
		type: payload.type as AppNotificationType,
		title: titleMap[payload.type as AppNotificationType],
		message: resolveMessage(payload.type, payload),
		created_at: payload.created_at ?? new Date().toISOString(),
		read: payload.read ?? false,
		recipient_user_id: payload.recipient_user_id ?? '',
		ticket_id: payload.ticketId ?? '',
		ticket_code: payload.ticketCode ?? '',
		subject: payload.subject ?? '',
		from_email: payload.from_email ?? '',
		icon: resolveIcon(payload.type)
	};
}


function resolveMessage(type: AppNotificationType, data: AppNotification): string {
	switch (type) {

		case 'TICKET_CREATED':
			return `Creato ticket<br> <b>${data.ticket_code}</b>`;

		case 'ASSIGNMENT_CHANGE_REQUESTED':
			return `Richiesta modifica assegnazione ticket<br> <b>${data.ticket_code}</b>`;

		case 'ASSIGNMENT_CHANGE_APPROVED':
			return `Cambio assegnazione approvato ticket<br> <b>${data.ticket_code}</b>`;

		case 'ASSIGNMENT_CHANGE_REJECTED':
			return `Cambio assegnazione rifiutato ticket<br> <b>${data.ticket_code}</b>`;

		case 'ASSIGNMENT_CHANGED_DIRECT':
			return `Ticket <b>${data.ticket_code}</b> riassegnato`;

		default:
			return 'Evento ticket';
	}
}

function resolveIcon(type: AppNotificationType): string {
	switch (type) {

		case 'TICKET_CREATED':
			return 'pi pi-ticket';

		case 'ASSIGNMENT_CHANGE_REQUESTED':
			return 'pi pi-question-circle';

		case 'ASSIGNMENT_CHANGE_APPROVED':
			return 'pi pi-check-circle';

		case 'ASSIGNMENT_CHANGE_REJECTED':
			return 'pi pi-times-circle';

		case 'ASSIGNMENT_CHANGED_DIRECT':
			return 'pi pi-user-edit';

		default:
			return 'pi pi-bell';
	}
}

const titleMap: Record<AppNotificationType, string> = {
	TICKET_CREATED: 'Nuovo ticket',
	ASSIGNMENT_CHANGE_REQUESTED: 'Richiesta cambio assegnazione',
	ASSIGNMENT_CHANGE_APPROVED: 'Cambio assegnazione approvato',
	ASSIGNMENT_CHANGE_REJECTED: 'Cambio assegnazione rifiutato',
	ASSIGNMENT_CHANGED_DIRECT: 'Ticket riassegnato'
};
